module.exports = __webpack_public_path__ + "static/media/logo-white.404babb7.svg";